import main from '../assets/images/main.svg';
import Wrapper from '../assets/wrappers/LandingPage';
import { Logo } from '../components';
import { useEthers } from '@usedapp/core';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { connect } from '../features/user/userSlice';
import { Button } from '@mui/material';

const Landing = () => {
  const dispatch = useDispatch();
  const { activateBrowserWallet, account, chainId } = useEthers();
  const { connected, web3Available } = useSelector((store) => store.user);
  if (connected) {
    return <Navigate to='/' />;
  }

  return (
    <Wrapper>
      <nav>
        <Logo />
      </nav>
      <div className='container page'>
        {/* info */}
        <div className='info'>
          <h1>
            Memori <span>NFT</span>
          </h1>
          <p>
            Celebrate your life with Memori NFT. Write a letter to your future
            self and loved ones. Unwind the clock and watch how you write letter
            by letter, word by word.
          </p>

          <Button
            variant='contained'
            color='primary'
            disabled={!web3Available}
            onClick={() => {
              if (account) {
                dispatch(connect({ account, chainId }));
              } else {
                activateBrowserWallet();
              }
            }}
          >
            {web3Available ? 'Connect' : 'Web3 Not Found'}
          </Button>
        </div>
        <img src={main} alt='job hunt' className='img main-img' />
      </div>
    </Wrapper>
  );
};

export default Landing;
